import { boot } from 'quasar/wrappers';
import { initializeApp, getApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence,
  initializeAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { VueFire, VueFireAuth } from 'vuefire';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

export const getFirebaseAuth = async () => {
  if (Capacitor.isNativePlatform()) {
    return initializeAuth(getApp(), {
      persistence: indexedDBLocalPersistence,
    });
  }
  return getAuth();
};

export const db = initializeFirestore(firebaseApp, {
  experimentalForceLongPolling: true,
});

export default boot(({ app }) => {
  app.use(VueFire, {
    firebaseApp,
    modules: [
      VueFireAuth(),
    ],
  });
});
